<template>
  <Card>
    <template #header>
      <h3>Testing</h3>
    </template>
  </Card>

  <Skeleton
    width="100%"
    height="100px"
  />
  <Skeleton
    width="100%"
    height="100px"
  />
  <Skeleton
    width="100%"
    height="100px"
  />
</template>

<script setup>
import Skeleton from '@/components/skeleton/Skeleton.vue'
</script>

<style scoped></style>
